<script>
  export let images;
  export let loop = true;
  export let per_page = 3;

  import Carousel from "@beyonk/svelte-carousel";
  //import Image from "./Image.svelte";
  import { ChevronLeftIcon, ChevronRightIcon } from "svelte-feather-icons";
</script>

<Carousel {loop} dots={false} perPage={per_page}>
  <span class="control" slot="left-control">
    <ChevronLeftIcon />
  </span>
  {#each images as img}
    <!-- svelte-ignore a11y-missing-attribute -->
    <div class="slide-content" style="--width: {100 / per_page}%">
      <img src={img} />
    </div>
  {/each}
  <span class="control" slot="right-control">
    <ChevronRightIcon />
  </span>
</Carousel>

<style>
  .slide-content {
    width: var(--width);
  }
</style>
